import { createSelector } from 'reselect'

const positionsSelector = state => state.positions.positions
const filterSelector = state => state.positions.filter
export const filteredSlection = createSelector(
  positionsSelector,
  filterSelector,
  (positions, {skill, company, location, role}) =>
    positions
      .filter(position => [
          ['skill', skill],
          ['company', company],
          ['location', location],
          ['role', role]
        ].every(([name, filter]) =>
          filter.length === 0 ||
          filter.some(({label, value}) =>
            value === '' ||
            (position[name] && position[name].toLowerCase().includes(label.toLowerCase()))
          )
        )
      )
      .sort(({date: a}, {date: b}) => new Date(a) - new Date(b))
)



// WEBPACK FOOTER //
// ./src/modules/selectors.js